module.exports = __webpack_public_path__ + "img/entrada_02.953c92cc.jpg";